import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Invoice } from 'src/app/Models/invoice.model';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-ptinvoices',
  templateUrl: './ptinvoices.component.html',
  styleUrls: ['./ptinvoices.component.css'],
})
export class PtinvoicesComponent implements OnInit {
  displayedColumns: string[] = [
    'PatientName',
    'Title',
    'Amount',
    'Date',
    'Status',
    'Print',
  ];
  // 'Description',
  // 'Units',
  // 'Duration',
  id = 0;
  invoiceList: Invoice[] = [];

  filteredList;
  dataSource: MatTableDataSource<any>;

  constructor(
    private patientService: PatientService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.getInvoice(this.id);
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getInvoice(id) {
    this.patientService.getPatieninvoices(id).subscribe((res) => {
      this.dataSource = new MatTableDataSource(res.Invoices);
      this.dataSource.paginator = this.paginator;
      //   this.filteredList = res.Invoices
      //  this.invoiceList= res.Invoices
    });
  }

  search(searchValue) {
    // console.log(searchValue);
    if (searchValue.value != null) {
      this.filteredList = this.invoiceList.filter((x) =>
        x.Title.toLowerCase().includes(searchValue.value.toLowerCase())
      );
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
